import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './firebase'

ReactDOM.render(<App/>, document.getElementById('root'));
